var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.SearchBox,{attrs:{"filterInputs":_setup.searchCardInputs,"headers":_setup._searchEstimateHeaders,"handle-search":_setup.searchButton,"search-res-items":_setup.searchRes,"handle-item-click":_setup.clickSearchedTr}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }